module.exports = __webpack_public_path__ + "static/img/14.6e1dd82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/14.jpg
// module id = ib0D
// module chunks = 1